export const calculateFees = (amount,fee_rate) => {
    if (typeof amount !== "number" || amount <= 0) {
        throw new Error("❌ Invalid amount provided. Amount must be a positive number.");
    }

     // If fee_rate is passed, apply flat fee
     if (fee_rate !== null && fee_rate !== undefined &&  fee_rate >= 0) {
        const platformFee = parseFloat(((amount * fee_rate) / 100).toFixed(2));
        const providerRevenue = parseFloat((amount - platformFee).toFixed(2));
        return { platformFee, providerRevenue };
      }

    // Define the tiers
    const tiers = [
        { limit: 250, rate: 14.99 },
        { limit: 500, rate: 12.99 },
        { limit: 750, rate: 9.99 },
        { limit: 1000, rate: 7.99 },
        { limit: Infinity, rate: 5.99 }
    ];

    let platformFee = 0;
    let remainingAmount = amount;

    for (let i = 0; i < tiers.length; i++) {
        const { limit, rate } = tiers[i];
        if (remainingAmount > 0) {
            const taxableAmount = Math.min(remainingAmount, limit - (tiers[i - 1]?.limit || 0));
            const fee = (taxableAmount * rate) / 100;
            platformFee += fee;
            remainingAmount -= taxableAmount;
        } else {
            break;
        }
    }

    platformFee = parseFloat(platformFee.toFixed(2)); // Round to 2 decimal places
    const providerRevenue = parseFloat((amount - platformFee).toFixed(2)); // Ensure correct precision

    return { platformFee, providerRevenue };
};